import { useEffect } from 'react';

const APP_SUFFIX = 'Arbi Docs';

/**
 * Sets document.title for the lifetime of the calling component. Concatenates as
 * `${page} — ${APP_SUFFIX}` when page is provided; falls back to APP_SUFFIX alone
 * otherwise. Restores the previous title on unmount.
 *
 * Per the locked naming convention (Sol 2026-05-06): arbi → 'Arbi', arbi-dev →
 * 'Arbi Dev', arbi-docs → 'Arbi Docs'. Each app hardcodes its suffix as a module
 * constant — no shared state, no runtime detection. The static index.html title
 * carries the same suffix for the pre-hydration paint.
 */
export function useDocumentTitle(page?: string): void {
  useEffect(() => {
    const prev = document.title;
    document.title = page && page.trim() ? `${page} — ${APP_SUFFIX}` : APP_SUFFIX;
    return () => {
      document.title = prev;
    };
  }, [page]);
}
